module.exports = __webpack_public_path__ + "img/cancel.3f61f8af.svg";